import Rails from '@rails/ujs'

/**
 * NOTE: vite での production ビルド時に、Railsの初期化が重複して行われるのを防ぐため、
 * `window._rails_loaded` フラグを使用して、初期化が一度だけ行われるようにしています。
 * このフラグは、Railsの初期化が完了した後に設定されます。
 * これにより、Railsの初期化が重複して行われることを防ぎます。
 * see. https://github.com/rails/rails/blob/9ab33753b6bab1809fc73d35b98a5c1d0c96ba1b/actionview/app/assets/javascripts/rails-ujs/start.coffee#L74
 * なお、開発環境では、毎回初期化が行われるため、
 * このフラグは主に本番環境での重複初期化を防ぐために使用されます。
 */
if (!window._rails_loaded) {
  Rails.start()
}
